import {ProductTourAnchorType} from '@toolify/client/src/modules/productTour/enum/ProductTourAnchorType'

export const PRODUCT_TOUR_ANCHOR_ATTRIBUTE = 'data-tour'

export function getProductTourAnchorSelector(anchor: ProductTourAnchorType): string {
  return `[${PRODUCT_TOUR_ANCHOR_ATTRIBUTE}="${anchor}"]`
}
